<template>
  <BreadCrumb PageTitle="Nouveau bon de paiment (Livreurs)" />
  <NewPaymentMod />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import NewPaymentMod from "@/components/Notes/Payments/Driver/NewPaymentMod.vue";

export default defineComponent({
  name: "NewPaymentModPage",
  components: {
    BreadCrumb,
    NewPaymentMod,
  },
});
</script>
